import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@sr/ui-library';
import { Control } from 'react-hook-form';
import { CountryCombobox } from '../../shared/CountryCombobox';
import { addressGroupRequiredString } from '../../shared/countryAwareStringSchema';
import { WORKSPACE_DETAILS_FORM_FIELDS } from '../../shared/fieldNames';
import { WorkspaceDetailsFormValues } from '../../shared/types';

interface AddressCountryFieldProps {
  control: Control<WorkspaceDetailsFormValues>;
}

/** Address country — drives the Google search restriction and field labels. */
export const AddressCountryField = ({ control }: AddressCountryFieldProps) => (
  <FormField
    name={WORKSPACE_DETAILS_FORM_FIELDS.addressCountry}
    control={control}
    render={({ field }) => (
      <FormItem>
        <FormLabel asterisk>Country</FormLabel>
        <FormControl>
          <CountryCombobox field={field} placeholder="Select a country" />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
);

AddressCountryField.schema = addressGroupRequiredString(
  WORKSPACE_DETAILS_FORM_FIELDS.addressCountry,
  (schema) => schema.required('Please select a Country'),
);
